export default __webpack_public_path__ + "static/media/file-type-png-icon.37a1056a.svg";